import { Heading } from '@printdeal/ui-library';
import React, { FC } from 'react';
import cx from 'clsx';
import { graphql } from 'gatsby';
import HubspotForm from '../hubspot/HubspotForm';

/** @knipignore */
export const fragment = graphql`
  fragment FormSection on ContentfulFormSectionConnection {
    nodes {
      hubspotForm
      title
      description
      node_locale
    }
  }
`;

export interface FormSectionForm {
  hubspotForm?: string;
  title?: string;
  description?: string;
  node_locale: string;
}

export interface FormSectionQueryData {
  data: {
    nodes?: FormSectionForm[];
  };
}

interface EmailOptInFormProps {
  className?: string;
  description?: string;
  hubspotFormId?: string;
  title?: string;
  variant?: 'vertical' | 'horizontal';
}

export const EmailOptInForm: FC<EmailOptInFormProps> = ({
  className,
  description,
  hubspotFormId,
  title,
  variant = 'vertical',
}) => {
  if (!hubspotFormId) return null;

  return (
    <div
      className={cx(className, {
        'md:pd-flex pd-flex-row pd-gap-10': variant === 'horizontal',
      })}
    >
      {title && (
        <Heading
          as="div"
          size="2"
          className={cx('pd-mb-6 pd-text-dim-800', {
            'pd-flex-grow pd-basis-1/2': variant === 'horizontal',
          })}
        >
          {title}
        </Heading>
      )}
      <div
        className={cx({
          'pd-flex-grow pd-flex-col pd-basis-1/2': variant === 'horizontal',
        })}
      >
        {description && <div className="pd-mb-2">{description}</div>}
        <HubspotForm
          formId={hubspotFormId}
          formClass="footer-newsletter-subscription-hubspot-form"
        />
      </div>
    </div>
  );
};
